const mutations = {
  SET_CURRENT_USER(state, data) {
    state.currentUser = data;
  },

  CLEAR_CURRENT_USER(state) {
    state.currentUser = null;
  },

  SET_REFERRER(state, data) {
    state.referrer = data;
  }
};

export default mutations;
